import { useCallback, useMemo } from "react";

import { PropallyApiFactory } from "@/module/CustomApiFactory";

import { useProposalDetails } from "./useProposalDetails";

export const useGetAssessmentProposalDetails = (id?: number) => {
  const fp = useMemo(() => PropallyApiFactory(), []);
  const fetchProposal = useCallback((proposalId: number) =>
    fp.v1AssessmentProposalsAssessmentProposalIdGet(proposalId, { withCredentials: true }), [fp]);
  const { refetch, ...state } = useProposalDetails(id, fetchProposal);
  return { ...state, fetchAssessmentProposalById: refetch };
};
